import request from '@/utils/request'

/**
 * 获取所有公众号
 */

export const getAllAccountData = (data) => {
  return request({
    url: 'yia/v1/account/page',
    method: 'GET',
    params: data
  })
}

/**
 * 新增公众号
 */
export const addAccount = (data) => {
  return request({
    url: 'yia/v1/account/save',
    method: 'POST',
    data
  })
}

/**
 * 删除公众号
 */
export const delAccount = (accountId) => {
  return request({
    url: `yia/v1/account/${accountId}`,
    method: 'DELETE'
  })
}

/**
 *  获取单个公众号
 */
export const getAccountById = (accountId) => {
  return request({
    url: `yia/v1/account/${accountId}`,
    method: 'GET'
  })
}

/**
 * 上传文件
 */
export const upload = (data) => {
  return request({
    method: 'POST',
    url: 'yia/v1/account/upload',
    data
  })
}

/**
 * 刷新公众号token
 */
export const refreshAccessToken = (path) => {
  return request({
    method: 'GET',
    url: `yia/v1/wx/client/${path}/refreshAccessToken`
  })
}

/**
 * 批量更新老数据，get请求
 */
export const accountUpdateBatch = (accountId, clinicId) => {
  return request({
    method: 'GET',
    url: `yia/v1/account/updateBatch/${accountId}`,
    params: {
      clinicId
    }
  })
}

/**
 * 改变公众号状态 失效->正常
 */
export const updateAccountStatus = (data) => {
  return request({
    method: 'POST',
    url: 'yia/v1/account/updateStatus',
    data
  })
}

/**
 * pc版本拼接连接  授权码有效时间10分钟
 */
export const getPreAuthCode = () => {
  return request({
    url: 'yia/v1/component/getPreAuthCode'
  })
}

/**
 * 首次获取刷新令牌 扫码成功后，跳转之后，获取到url上的code之后调如下接口
 */
export const getAuthorizerRefreshToken = (authorizationode) => {
  return request({
    url: `yia/v1/component/getAuthorizerRefreshToken/${authorizationode}`
  })
}
